const AuthGuard = ({ store, router }) => {
  router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['auth/isAuthenticated']

    if (to.meta && 'anonymous' in to.meta) {
      return next()
    }
    if (isAuthenticated) {
      return next()
    }

    return next('/login')
  })
}

export { AuthGuard }
